import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppSelectors } from 'projects/semeris/src/store/app/app.selectors';
import { UserProfileSelectors } from 'projects/semeris/src/store/user-profile/user-profile.selectors';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { PermissionService } from './permission.service';
import { SemerisRoutes } from '../constants/routes';

@Injectable({ providedIn: 'root' })
export class WelcomeGuard implements CanActivate {
  private readonly permissionService = inject(PermissionService);
  private readonly store = inject(Store);
  private router = inject(Router);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(UserProfileSelectors.assetShortNames).pipe(filter((a) => !!a)),
      this.store.select(AppSelectors.assets).pipe(filter((a) => !!a)),
      this.permissionService.hasAnyPermission$,
      this.permissionService.verified$,
    ]).pipe(
      take(1),
      map(([assets, appAssets, hasAnyPermission, verified]) => {
        if (!verified) {
          return true;
        }

        return hasAnyPermission && appAssets.length && assets.length
          ? this.router.createUrlTree(['/', SemerisRoutes.home.root])
          : true;
      })
    );
  }
}
